/**
 * Remotion 에디터에서 밀리초 단위 시간을 받아 00:00 또는 00:00:00 형태로 표현한다.
 * @param milliseconds 밀리초 단위의 전체 시간 값
 * @returns 1시간 미만이면 mm:ss, 1시간 이상이면 hh:mm:ss 형식의 문자열
 */
export const renderTimesMs = (milliseconds?: number): string => {
  if (!Number.isFinite(milliseconds) || !milliseconds) {
    return '00:00';
  }

  const clampedMilliseconds = Math.max(0, Math.floor(milliseconds));
  const totalSeconds = Math.floor(clampedMilliseconds / 1000);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  const minutesString = String(minutes).padStart(2, '0');
  const secondsString = String(secs).padStart(2, '0');

  if (hours === 0) {
    return `${minutesString}:${secondsString}`;
  }

  const hoursString = String(hours).padStart(2, '0');

  return `${hoursString}:${minutesString}:${secondsString}`;
};
